import { categoryNames } from "../../../shared/lib/constants"

export const selectValues = Object.entries(categoryNames).reduce((acc, curr) => {
  acc.push({ value: curr[0], label: curr[1] })
  return acc
}, [] as Array<{ value: string, label: string }>)
